<template>
  <div>
    <slot v-if="seen"></slot>
  </div>
</template>

<script>
import ViewablePanel from '@/mixins/ViewablePanel.js'
export default {
  mixins: [ViewablePanel]
}
</script>

<style>

</style>